import delay from 'delay';
import { type LessonIguanaObject } from 'Lessons';

// On iOS a `delay(0)` costs more than the work it interrupts.
const YIELD_BUDGET_MS = 50;

async function recursivelyGetImageUrls(lesson: LessonIguanaObject<true>) {
    const results: string[] = [];
    let lastYieldAt = performance.now();

    // FIXME: these awaits inside of a loop are awkward, but
    // necessary.  We need to throttle things to keep from
    // locking up the browser. We also `delay(0)` as our underlying
    // `recursivelyGetImageUrls` logic resolves with `$q.when`
    // For more info, see https://trello.com/c/5yQMSVoI
    for (let i = 0; i < lesson.frames.length; i += 1) {
        const frame = lesson.frames[i].reify();
        // oxlint-disable-next-line no-await-in-loop
        const result = await frame.recursivelyGetImageUrls();
        if (result) results.push(...result);

        if (performance.now() - lastYieldAt >= YIELD_BUDGET_MS) {
            // oxlint-disable-next-line no-await-in-loop
            await delay(0);
            lastYieldAt = performance.now();
        }
    }

    return results;
}

export default async function getImageUrlsForLesson(
    // FIXME:  it would be nice to do this without componentized iguana models, but
    // it seemed like it would require quite a bit of refactoring.
    lesson: LessonIguanaObject<true>,
) {
    return [...new Set(await recursivelyGetImageUrls(lesson))];
}
